import React, { useState } from 'react';
import
{ Carousel, CarouselItem, CarouselControl, CarouselIndicators, CarouselCaption, } from 'reactstrap';

const items = [
    {
        src: '/assets/slider/kapanis.jpg',
        link : ''
    },
    {
        src: '/assets/slider/acilis.jpg',
        link : ''
    },
    {
        src: '/assets/slider/homePicture.jpg?v=6',
        link : ''
    },
    {
        src: '/assets/slider/acilis-programi.jpg?v=6',
        link : ''
    },
    {
        src: '/assets/slider/fuar-alani.jpg?v=6',
        link : ''
    },
    {
        src: '/assets/slider/10-ocak.jpg?v=6',
        link : '/assets/slider/10-ocak.pdf?v=6'
    },
    {
        src: '/assets/slider/11-ocak.jpg?v=6',
        link : '/assets/slider/11-ocak.pdf?v=6'
    },
    {
        src: '/assets/slider/etkinlik.jpg?v=6',
        link : '/assets/slider/etkinlik.pdf?v=6'
    }
];

function SliderCarousel(args)
{
    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);

    const next = () =>
    {
        if (animating) return;
        const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    };

    const previous = () =>
    {
        if (animating) return;
        const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    };

    const goToIndex = (newIndex) =>
    {
        if (animating) return;
        setActiveIndex(newIndex);
    };

    const slides = items.map((item) => {

        let content;
        if (item.link == '') {
          content = (
            <img src={item.src} className="w-100" />
          );
        } else {
            content = (
                <a href={item.link} target='_blank'>
                    <img src={item.src} className="w-100" />
                </a>
            );
        }
      
        return (
          <CarouselItem
            onExiting={() => setAnimating(false)}
            onExited={() => setAnimating(false)}
            key={item.src}
            className="h-100"
          >
            {content}
          </CarouselItem>
        );
      });
      

    return (
        <Carousel
            activeIndex={activeIndex}
            next={next}
            previous={previous}
            interval={3000}
            {...args}
            className="fluid"
        >
            <CarouselIndicators
                items={items}
                activeIndex={activeIndex}
                onClickHandler={goToIndex}
            />
            {slides}
            <CarouselControl
                direction="prev"
                directionText="Previous"
                onClickHandler={previous}
            />
            <CarouselControl
                direction="next"
                directionText="Next"
                onClickHandler={next}
            />
        </Carousel>
    );
}

export default SliderCarousel;
